export default "__VITE_ASSET__7DNoHgbB__"